// Constants for different requests for current reducer
export default {
  activeIRsGroupedByType: 'ACTIVE_IRS_GROUPED_BY_TYPE',
  irsGroupedByDateAndType: 'IRS_GROUPED_BY_DATE_AND_TYPE',
  irsGroupedByDate: 'IRS_GROUPED_BY_DATE',
  setLoadingState: 'STATISTICS_SET_LOADING_STATE',
};
